import "../../../assets/scss/payment-style.scss";

import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, message, Progress, Select, Spin } from "antd";

import {
  ApiOutlined,
  ArrowUpOutlined,
  ArrowDownOutlined,
  DatabaseOutlined,
  DesktopOutlined,
  RobotOutlined,
  SaveOutlined,
  ThunderboltFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import {
  removeSelectionInfo,
  updateGPUCountSelectionInfo,
} from "../../features/selection/selectionSlice";
import { returnkW } from "../../utility/fn";
import { clearAllSessions } from "../../utility/common/session-store";
import {getInstanceDetail} from "../../server/Instances";

export const RentSummary = () => {
  const { t } = useTranslation();
  const userState = useAppSelector((state: any) => state.user);
  const selectionState = useAppSelector((state: any) => state.selection);
  // const [instanceID, setInstanceID] = useState<string>(""); //TODO: QUICKWORKAROUND to be replaced later
  const [displayRentMessage, setDisplayRentMessage] = useState<string>("");
  const [rentStatus, setRentStatus] = useState<string>("");
  const instanceLoadingStatusState = useAppSelector(
    (state: any) => state.instanceStatus.id
  );

  const [totalPrice, setNewTotalPrice] = useState<number | string>(
    Number(selectionState.gpu.price)
  ); // 總價
  const [options, setOptions] = useState<any[]>([]); // 可選張數
  const [amount, setNewAmount] = useState<number>(1); // 選擇張數
  const [loading, setLoading] = useState<boolean>(false);
  // const [loadingMessage, setLoadingMessage] = useState<string>("");
  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const API_ROUTE = process.env.REACT_APP_API_BASE_URL;

  const selectedAll = selectionState.gpu.selected_as_whole;
  let token = userState.token.access_token;

  const startGPURental = () => {
    setLoading(true);
    fetch(`${API_ROUTE}instances`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
        Accept: "text/event-stream",
      },
      body: JSON.stringify({
        gpu_count: selectionState.selected_gpu_count,
        host_id: selectionState.gpu.host_id,
        service_name: "test1234",
        runtime: "nvidia",
        template_id: selectionState.template_id,
      }),
    });
    setTimeout(() => {
      navigate("/instances");
    }, 1000);
  };

  const startGPURentalSSE = async () => {
    setLoading(true);
    try {
      // Step 1: Make the API call directly with fetch
      const response = await fetch(`${API_ROUTE}instances`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "text/event-stream",
        },
        body: JSON.stringify({
          gpu_count: selectionState.selected_gpu_count,
          host_id: selectionState.gpu.host_id,
          service_name: "test1234",
          template_id: selectionState.template_id,
          user_id: userState.user_id,
        }),
      });

      if (!response.ok) {
        if (response.status === 401) {
          clearAllSessions();
          window.location.href = "/login";
          window.location.reload();
        }
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      if (response.ok) {
        navigate("/instances");
      }

      if (response.body) {
        const reader = response.body.getReader(); // ✅ Only one reader is created
        const decoder = new TextDecoder();
        let buffer = "";

        //TODO: QUICKWORKAROUND to be deleted later
        // const instanceResponse = await getInstances();
        // const data = await instanceResponse.data;
        // if (data.instances !== null) {
        //   console.log(data.instances[0].inqstance_id);
        //   setInstanceID(data.instances[0].instance_id);
        // }

        while (true) {
          const { value, done } = await reader.read();
          if (done) break;

          // Decode the streamed data and store it in a buffer
          buffer += decoder.decode(value, { stream: true });

          // Process complete messages (SSE messages end with "\n\n")
          let lines = buffer.split("\n");
          buffer = lines.pop() || ""; // Save incomplete data for next loop

          lines.forEach((line) => {
            line.split("\n").forEach((msg) => {
              if (msg.startsWith("data: {")) {
                try {
                  let lineObj = JSON.parse(line.split("data:")[1]);
                  setDisplayRentMessage(lineObj.message);
                  setRentStatus(lineObj.status);
                } catch (error) {
                  console.warn("Failed to parse SSE JSON:", msg);
                }
              }
            });
          });
        }

        // Close the reader when the loop ends
        reader.releaseLock();
      }
    } catch (error) {
      console.error("Error in rent function:", error);
    }
  };

  const rentSuccess = () => {
    messageApi.success(t("Download Success!"));
  };

  const rentFailed = () => {
    messageApi.error(t("Download Failed!"));
  };

  // TODO: quick work around for message, backend SSE to be fixed later
  // const currentStatusMessage = useMemo(() => {
  //   if (!instanceID) return "";

  //   const found = instanceLoadingStatusState.find(
  //     (item: any) => item.instanceID === instanceID
  //   );

  //   return found?.message || "";
  // }, [instanceID, instanceLoadingStatusState]);

  // useEffect(() => {
  //   setLoadingMessage(currentStatusMessage);
  // }, [currentStatusMessage]);

  useEffect(() => {
    // this creates the select options for amt
    if (selectionState.gpu) {
      let optionArray = Array.from(
        { length: Number(selectionState.gpu.gpu_available) },
        (_, i) => ({
          value: i + 1,
          label: i + 1,
        })
      );
      setOptions(optionArray);
    }
  }, [selectionState]);

  useEffect(() => {
    let newPrice = Number(selectionState.gpu.price) * amount;
    let decimals = newPrice.toFixed(2);
    setNewTotalPrice(decimals);
  }, [amount]);

  useEffect(() => {
    if (rentStatus === "completed") {
      rentSuccess();
      setLoading(false);
      navigate("/instances");
      dispatch(removeSelectionInfo()); // clears the original selection
    } else if (rentStatus === "error") {
      rentFailed();
      setLoading(false);
      dispatch(removeSelectionInfo()); // clears the original selection
    }
  }, [rentStatus]);

  useEffect(() => {
    if (selectedAll === undefined) {
      // prevent user from refreshing and loading the summary page
      navigate("/");
    }

    if (selectedAll === false) {
      let count = 1;
      let newPrice = Number(selectionState.gpu.price) * count;
      let decimals = newPrice.toFixed(2);
      dispatch(updateGPUCountSelectionInfo(count));
      setNewAmount(count);
      setNewTotalPrice(decimals);
    }

    if (selectedAll === true) {
      let count = selectionState.gpu.total_gpu_count;
      let newPrice = Number(selectionState.gpu.price) * count;
      let decimals = newPrice.toFixed(2);
      dispatch(updateGPUCountSelectionInfo(count));
      setNewAmount(count);
      setNewTotalPrice(decimals);
    }
  }, []);

  return (
    <>
      {contextHolder}
      <div className="wrapper">
        <h4>{t("Order Details")}</h4>

        <div className="payment-table">
          <div className="payment-table-row payment-table-header">
            <div className="payment-table-cell">{t("Product Details")}</div>
            <div className="payment-table-cell">{t("Available GPUs")}</div>
            <div className="payment-table-cell">{t("Price Per Unit")}</div>
            <div className="payment-table-cell">{t("Amount")}</div>
            <div className="payment-table-cell">{t("Price")}</div>
          </div>
          <div className="payment-table-row">
            <div className="payment-table-cell">
              <h3>{selectionState.gpu.product_name}</h3>
            </div>
            <div className="payment-table-cell">
              <strong>{selectionState.gpu.gpu_available}</strong> {t("GPUs")}
            </div>
            <div className="payment-table-cell">
              <strong>USD ${selectionState.gpu.price}</strong>
            </div>
            <div className="payment-table-cell">
              {selectedAll ? (
                <>{selectionState.selected_gpu_count}</>
              ) : (
                <>
                  <Select
                    defaultValue="1"
                    style={{ width: "auto" }}
                    disabled={selectionState.gpu.gpu_available === 0 || loading}
                    onChange={(value: string) => {
                      dispatch(updateGPUCountSelectionInfo(+value));
                      setNewAmount(+value);
                    }}
                    options={options}
                  />
                </>
              )}
            </div>
            <div className="payment-table-cell">
              <strong>
                USD ${totalPrice}
                <b> /{t("Per Hour")}</b>
              </strong>
            </div>
          </div>
        </div>

        <ul className="product-details">
          <li className="speed-wrapper">
            <span className="speed-title">
              <ApiOutlined />
              &nbsp;{t("Internet Speed")}:
            </span>
            <div className="speed">
              <span>
                <ArrowUpOutlined /> {selectionState.gpu.internet_upload_speed}{" "}
                Mbps
              </span>
              <span>
                <ArrowDownOutlined />{" "}
                {selectionState.gpu.internet_download_speed} Mbps
              </span>
            </div>
          </li>
          <li>
            <DesktopOutlined /> {t("GPU RAM")}: {selectionState.gpu.gpu_ram} GB
          </li>
          <li>
            <RobotOutlined /> CPU: {selectionState.gpu.cpu_name}
          </li>
          <li>
            <SaveOutlined /> {t("Effective RAM")}:{" "}
            {selectionState.gpu.effective_ram} GB
          </li>
          <li>
            <DatabaseOutlined /> {t("Disk Storage")}:{" "}
            {selectionState.gpu.disk_max_available_storage}
            GB
          </li>
          <li>
            <ThunderboltFilled /> {t("Watt")}:{" "}
            {returnkW(selectionState.gpu.product_name)} kWatt
          </li>
        </ul>
      </div>
      <div className="wrapper">
        <div className="rent-status">
          <div className="rental-details">
            <div className="rent">
              {displayRentMessage}
              {/* {loadingMessage} */}
              {/* TODO: // QUICKWORKAROUND to be replaced later */}
              {loading && (
                <div className="rent-loading">
                  <Spin
                    indicator={
                      <LoadingOutlined style={{ fontSize: 48 }} spin />
                    }
                  />
                </div>
              )}
            </div>
            {!loading && (
              <Button
                type="primary"
                disabled={selectionState.gpu.gpu_available === 0}
                onClick={() => startGPURental()}
              >
                {t("Rent")}
              </Button>
            )}{" "}
          </div>
        </div>
      </div>
    </>
  );
};
